// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25bAy","label":"styles_label__2fwqo"};